import PageBreadcrumb from "../components/common/PageBreadCrumb";
import PageMeta from "../components/common/PageMeta";
import ShippingTable from "../components/tables/ShippingTable";

export default function ShippingPage() {
    return (
        <>
            <PageMeta
                title="Shipping | Shoplattice Admin Dashboard"
                description="View shipping services and rates"
            />
            <PageBreadcrumb pageTitle="Shipping" />
            <div className="space-y-6">
                <ShippingTable />
            </div>
        </>
    );
}
